export default "__VITE_ASSET__a1854577__"